import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.to-fixed.js";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import moment from "moment";
import { iconColor } from "@/consts/iconColor";
var __default__ = {
  name: "LatestAttendanceCounter",
  filters: {
    mmdd: function mmdd(value) {
      if (!value) return "";
      value = value.toString();
      return value.slice(5);
    }
  },
  data: function data() {
    return {
      summary: []
    };
  },
  computed: _objectSpread({}, mapState(["classrooms"])),
  created: function created() {
    var _this = this;

    this.setData(); // 毎分更新

    this.intervalId = setInterval(function () {
      return _this.setData();
    }, 1000 * 60 * 3);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    iconColor: iconColor,
    setData: function setData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, classAttendanceObj, today;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getData("reader/get_assigned_class_attendance_summary").catch(function (error) {
                  console.log(error);
                });

              case 2:
                data = _context.sent;

                if (!(!data || !data.items)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                classAttendanceObj = data.items;
                today = moment().format("YYYY-MM-DD");
                _this2.summary = _this2.classrooms.filter(function (v) {
                  return classAttendanceObj[v.id];
                }).map(function (v) {
                  var counterSummary = {
                    attendance: {
                      absence: 0,
                      late: 0,
                      leave: 0,
                      noAttend: 0
                    },
                    classroom: v,
                    attendanceList: [],
                    absenceRate: 0
                  };
                  classAttendanceObj[v.id].forEach(function (v2) {
                    if (v2.date === today && v2.is_daily_latest) {
                      // 当日分かつ最新のデータのみクラス別人数を数字で出す
                      var type = v2.type.split("-")[0];

                      switch (type) {
                        case "欠席":
                          counterSummary.attendance.absence += 1;
                          break;

                        case "遅刻":
                          counterSummary.attendance.late += 1;
                          break;

                        case "早退":
                          counterSummary.attendance.leave += 1;
                          break;

                        case "遅刻早退":
                          counterSummary.attendance.late += 1;
                          counterSummary.attendance.leave += 1;
                          break;

                        case "未登校":
                          counterSummary.attendance.noAttend += 1;
                          break;
                      }
                    }

                    counterSummary.attendanceList.push({
                      id: v2.id,
                      date: moment(v2.date).format("YYYY年MM月DD日"),
                      createdAt: moment(v2.created_at).format("MM月DD日 HH時mm分"),
                      updatedAt: v2.updated_at,
                      studentName: v2.student.name ? v2.student.name.replace(/\s+/, " ") : "",
                      studentId: v2.student_id,
                      type: v2.type,
                      guardianMemo: v2.guardian_memo,
                      comment: v2.comment,
                      isDeleted: !v2.is_daily_latest
                    });
                  });
                  counterSummary.attendanceList = counterSummary.attendanceList.sort(function (a, b) {
                    return a.updatedAt < b.updatedAt ? 1 : -1;
                  });
                  counterSummary.attendanceList.forEach(function (v) {
                    v.isHistory = Boolean(v.isDeleted && counterSummary.attendanceList.filter(function (v2) {
                      return v.studentId === v2.studentId && v.date === v2.date;
                    }).length > 1);
                  });
                  var attendance = [];
                  counterSummary.attendanceList.forEach(function (v) {
                    var historyStudentArray = attendance.find(function (v2) {
                      return v2[0].studentId === v.studentId && v2[0].date === v.date;
                    });

                    if (historyStudentArray) {
                      historyStudentArray.push(v);
                    } else {
                      attendance.push([v]);
                    }
                  });

                  if (counterSummary.attendance.absence > 0 && v.students_count > 0) {
                    counterSummary.absenceRate = (counterSummary.attendance.absence / v.students_count * 100).toFixed(1);
                  }

                  return counterSummary;
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // import { inject } from "vue";
    // const attendanceMode = inject("attendanceMode");
    // const changeAttendanceMode = () => {
    //   attendanceMode.value = "info";
    // };
    return {
      __sfc: true,
      iconColor: iconColor
    };
  }
});